import React from 'react';

type Props = {
    t: (key: string) => string;
    children: React.ReactElement;
};

type State = {
    hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: unknown, errorInfo: unknown) {
        console.error(error, errorInfo);
    }

    render() {
        const { t, children } = this.props;
        const { hasError } = this.state;

        if (hasError) return <h1>{t('routerErrors.errorBoundary')}</h1>;

        return children;
    }
}

export default ErrorBoundary;
